import { createSelector } from '@ngrx/store';

import { selectSelectedStoreProducts } from '../store-funnel';

export const selectStoreReceiptViewModel = createSelector(
  selectSelectedStoreProducts,
  (selectedProducts) => ({ selectedProducts })
);
